import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";

import { redirectUrls } from "../../models/settings";
import { Panel, PanelHeader } from "../Surfaces";
import { DropZone } from "../Input";
import { LoadButton } from "../Button";
import usePostData from "../../models/usePostData";
import useStore from '../../store/useStore';
import { ConfirmationDialog } from "../Dialogs";

/** FieldsForm constructs a fields form to drag and drop shape image files with field definitions or to connect to eHerkenning to retrieve field definitions */
const ImageFileForm = () => {
    const [ files, setFiles ] = useState([]);
    const [ imagefileProcess, setImagefileProcess ] = useState(-1);
    const { dispatch } = useStore();
    const { uploadImageFile } = usePostData();
    const [ confirmationState, setConfirmationState ] = useState(false);
    const navigate = useNavigate();
    const [alertState, setAlertState] = useState({ message: null, severity: "error" });
    
    const showError = (msg) => setAlertState({ message: msg, severity: "error" });

    const handleSubmit = (event) => {
        if (files.length === 0) {
            setImagefileProcess(0);
            setConfirmationState(true);
        } else {
            setImagefileProcess(1);
        }
    }

    function proceedOnConfirmation(confirmation) {
        if (confirmation) {
            setImagefileProcess(1);
        } else {
            setImagefileProcess(-1);
        }

        setConfirmationState(false);
    }

    useEffect(() => {
        if (files.length === 0) return;

        showError(null);
    }, [ files ]);

    useEffect(() => {
        if (imagefileProcess === 1) {
            setImagefileProcess(2);
            uploadImageFile(files)
            .then((response) => { 
                setFiles([]);
                dispatch({ type: 'SET_IMAGE', payload: response.value });
                dispatch({ type: 'SET_RESULT', payload: response.message });
                setImagefileProcess(-1);
                navigate(redirectUrls.overview);
            })
            .catch((err) => {
                setFiles([]);
                setImagefileProcess(-1);
                showError("The image file cannot be uploaded.");
                console.error(err);
            });
        }
    }, [ imagefileProcess ]);

    return (
        <Panel centered="true" width="1000px">
            <PanelHeader>Load Image File</PanelHeader>
            {alertState?.message && (<Alert severity={alertState.severity}>{alertState.message}</Alert>)}
            <Grid container sx={{ mt: 3 }}>
                <Grid item xs={12}>
                    <DropZone files={files} setFiles={setFiles} title="Drag and drop an image file (JPEG or PNG)"/>
                    <LoadButton id="imagefiles" loading={imagefileProcess === 2} onClick={handleSubmit} style={{marginTop: 10}}>
                        Load image file
                    </LoadButton>
                </Grid>            
            </Grid>

            <ConfirmationDialog 
                open={confirmationState} 
                handleClose={proceedOnConfirmation} 
                title="No image file" 
                question={"Please select an image file."}
            ></ConfirmationDialog>
        </Panel>
    );
}

export default ImageFileForm;